const en = {
  buyExam: "Buy Mock Exam",
  makePayment: "Make Payment",
  candidateDetails: "Candidate Details",
  fullName: "Full Name",
  phoneNumber: "Phone Number",
  email: "Email",
  fillDetails: "Please, fill up the details below:",
  residenceCountry: "Country of Residence",
  Other: "Other",
  Uzbekistan: "Uzbekistan",
  passportNo: "Passport or ID Number (e.g. AA1234567)",
  invalidPassportNo: "Please input a correct passport or ID number.",
  dob: "Date of Birth",
  wrongPassportOrDob: "Wrong Passport or Date of Birth, please check",
  proceed: "PROCEED",
  firstName: "First Name (per PASSPORT)",
  lastName: "Last Name (per PASSPORT)",
  disclaimer: "Disclaimer",
  disclaimerText:
    "These TKT mock test materials are unofficial and are not endorsed by or affiliated with Cambridge English. All content, including questions, answers, and explanations, has been generated by Edu-Action Exams Centre and is fully unique. The materials provided are for practice purposes only and do not replicate any official TKT exam content. The main aim of these mock tests is to give candidates a real exam atmosphere with a time limit. Candidates should refer to official Cambridge English resources for authoritative information.",
  processingFee: "Processing Fee",
  totalPay: "Total to Pay",
  price: "Price",
  cardNo: "Card Number",
  validThru: "Valid Thru",
  phoneNo: "Phone Number",
  enterCode: "Enter the code from the SMS",
  pay: "PAY",
  securePaymentTitle: "Secure Payment Processing:",
  securePayment1:
    "Your security is our priority. We do not store your card details. All payments are securely processed through",
  securePayment2:
    "a trusted third-party service. Enjoy peace of mind with end-to-end encryption and OTP verification for added security.",
  codeSent: "Code is sent to ",
  paidSuccess: "You have successfully paid for your Mock Exam",
  moduleNA:
    "There is no available test on this module at the moment. Please check again later.",
  selectModule: "Select Module",
  passportOrDobWrong: "Passport ID or Date of Birth is wrong, please check",
  testDetails: "Test Details",
  finished: "Finished",
  boughtOn: "Bought on",
  takeTest: "Take the test",
  takeTest1: "You can take the test",
  takeTest2: "here",
  changePassword: "Change Password",
  logout: "Logout",
  regiterTitle: "Mock Test Registration",
  register: "Register",
  registerTitle: "Registration for Mock Test",
  password: "Password",
  passwordConfirm: "Confirm the Password",
  alreadyRegistered: "Already registered? Login",
  smthWentWrong: "Something went wrong, please try again",
  enterCorrectPhone: "Please enter correct phone number",
  passwordsNotMatch: "Passwords do not match",
  repeatPassword: "Repeat your password",
  atLeast6: "Value must be at least 6 characters",
  enterPassword: "Please enter your password",
  enterEmail: "Please enter your email",
  enterPhone: "Please enter your phone number",
  enterLastName: "Please enter your last name",
  enterFirstName: "Please enter your first name",
  loginText: "Please use your credentials to login",
  login: "Login",
  forgotPassword: "Forgot Password",
  notRegistered: "Not Registered yet?",
  submit: "Submit",
  checkYourEmail: "Please check your email",
  forgotPasswordText:
    "Please use your registered email to receive reset password link.",
  enterNewPassword: "Please enter new password",
  enterOldPassword: "Please enter your old password",
  passwordsShouldMatch: "New and Confirm passwords should match",
  resetPasswordText: "Please think of a new password.",
  resetPassword: "Reset Password",
  newPassword: "New Password",
  oldPassword: "Old Password",
  changePasswordText: "Please use your old passsword to set a new password.",
  backHome: "Back to Home",
  trainings: "Training Videos",
  mockExams: "Mock Exams",
  training: "Training",
  videos: "videos",
  video: "Video",
  playlist: "Playlist",
  watch: "Watch",
};

export default en;
